

























import { defineComponent } from 'vue';
import { uiMgr } from '../common/uiMgr';

export default defineComponent({
  name: 'NoTicket',
  props: {
    showBuyBtn: {
      type: Boolean,
      default: true,
    },
    showAll: {
      type: Boolean,
      default: true,
    },
  },
  setup() {
    const handleBuy = () => {
      uiMgr.pushPage({
        name: 'Bounty',
      });
    };

    return {
      handleBuy,
    };
  },
});
